var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.002 7.124a5.028 5.028 0 0 1-1.482 3.58 5.026 5.026 0 0 1-3.579 1.481 5.024 5.024 0 0 1-3.577-1.482 5.068 5.068 0 0 1 0-7.158 5.028 5.028 0 0 1 3.577-1.48 5.03 5.03 0 0 1 3.58 1.48 5.028 5.028 0 0 1 1.481 3.58zm-.313 3.701a5.937 5.937 0 0 0 1.272-3.7 5.977 5.977 0 0 0-1.764-4.257 5.974 5.974 0 0 0-4.255-1.76 5.979 5.979 0 0 0-4.256 1.76 6.027 6.027 0 0 0 0 8.512 5.981 5.981 0 0 0 4.255 1.764c1.53 0 2.98-.572 4.098-1.614l3.42 3.42.678-.678-3.447-3.447z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.97 7.325v.142h.958v-.142A3.217 3.217 0 0 1 7.142 4.11h.141v-.958h-.14A4.176 4.176 0 0 0 2.97 7.325"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchSmall);
export default __webpack_public_path__ + "static/media/search-small.68013103dc15c9fdce0f94833651b586.svg";
export { ForwardRef as ReactComponent };